document.addEventListener('DOMContentLoaded', function () {
  function formatMoney(cents, currencyCode) {
    var amount = Number(cents || 0) / 100;
    var formattedAmount = amount.toLocaleString(undefined, {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return (currencyCode || window.DecodeMarketCurrency || 'AED') + ' ' + formattedAmount;
  }

  function updateCard(card) {
    var variantsEl = card.querySelector('[data-variants-json]');
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var select1 = card.querySelector('[data-option-select="option1"]');
    var packBtns = card.querySelectorAll('[data-pack-value]');
    var variantInput = card.querySelector('[data-variant-id]');
    var priceEl = card.querySelector('[data-price]');
    var compareEl = card.querySelector('[data-compare-price]');
    var saleBadgeEl = card.querySelector('[data-sale-badge]');
    var atcBtn = card.querySelector('[data-atc-button]');
    var moneyFormat = card.getAttribute('data-currency-code') || window.DecodeMarketCurrency || 'AED';

    var selectedOption1 = select1 ? select1.value : null;
    var activePackBtn = card.querySelector('[data-pack-value].active');
    var selectedOption2 = activePackBtn ? activePackBtn.getAttribute('data-pack-value') : null;

    var matchedVariant = variants.find(function(v) {
      var option1Match = selectedOption1 ? v.option1 === selectedOption1 : true;
      var option2Match = selectedOption2 ? v.option2 === selectedOption2 : true;
      return option1Match && option2Match;
    });

    if (!matchedVariant && selectedOption1) {
      matchedVariant = variants.find(function(v) {
        return v.option1 === selectedOption1;
      });
    }

    if (!matchedVariant && selectedOption2) {
      matchedVariant = variants.find(function(v) {
        return v.option2 === selectedOption2;
      });
    }

    if (!matchedVariant && variants.length) {
      matchedVariant = variants[0];
    }

    if (!matchedVariant) return;

    if (variantInput) variantInput.value = matchedVariant.id;

    if (priceEl) {
      priceEl.textContent = formatMoney(matchedVariant.price, moneyFormat);
    }

    if (compareEl) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        compareEl.style.display = '';
        compareEl.textContent = formatMoney(matchedVariant.compare_at_price, moneyFormat);
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (saleBadgeEl) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        var discount = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price);
        saleBadgeEl.style.display = '';
        saleBadgeEl.textContent = '(' + discount + '%)';
      } else {
        saleBadgeEl.style.display = 'none';
      }
    }

    if (packBtns.length && matchedVariant.option2) {
      packBtns.forEach(function(btn) {
        btn.classList.toggle('active', btn.getAttribute('data-pack-value') === matchedVariant.option2);
      });
    }

    if (select1 && matchedVariant.option1 && select1.value !== matchedVariant.option1) {
      select1.value = matchedVariant.option1;
    }

    if (atcBtn) {
      atcBtn.disabled = !matchedVariant.available;
      atcBtn.textContent = matchedVariant.available ? 'Add to cart' : 'Sold out';
    }
  }

  function initCollectionCards(scope) {
    var cards = (scope || document).querySelectorAll('[data-product-card]');
    cards.forEach(function(card) {
      var select1 = card.querySelector('[data-option-select="option1"]');
      var packBtns = card.querySelectorAll('[data-pack-value]');

      if (select1 && !select1.dataset.bound) {
        select1.dataset.bound = 'true';
        select1.addEventListener('change', function() {
          updateCard(card);
        });
      }

      if (packBtns.length) {
        packBtns.forEach(function(btn) {
          if (!btn.dataset.bound) {
            btn.dataset.bound = 'true';
            btn.addEventListener('click', function() {
              packBtns.forEach(function(b) { b.classList.remove('active'); });
              btn.classList.add('active');
              updateCard(card);
            });
          }
        });
      }

      updateCard(card);
    });
  }

  initCollectionCards(document);

  document.addEventListener('shopify:section:load', function(evt) {
    initCollectionCards(evt.target);
  });
});